import Thank from './Thank.vue'
import UserHistory from './UserHistory.vue'
import CheckBookingNext from './CheckBookingNext.vue'
import BookingFormEmp from './BookingFormEmp.vue'
import CalendarBookingEmp from './CalendarBookingEmp.vue'
import EmpList from './EmpList.vue'

export default {
  BookingFormEmp,
  Thank,
  UserHistory,
  CheckBookingNext,
  CalendarBookingEmp,
  EmpList
}



// WEBPACK FOOTER //
// ./src/components/TCG/index.js